import type { AgendaPermission } from '@/services/agendas'

export const AGENDA_PERMISSIONS = {
  INVITE_MEMBERS: 'CanInviteMembers' as AgendaPermission,
  REMOVE_MEMBERS: 'CanRemoveMembers' as AgendaPermission,
  MANAGE_PERMISSIONS: 'CanManagePermissions' as AgendaPermission,
  VIEW_EVENTS: 'CanViewEvents' as AgendaPermission,
  EDIT_EVENTS: 'CanEditEvents' as AgendaPermission,
  VIEW_NOTES: 'CanViewNotes' as AgendaPermission,
  EDIT_NOTES: 'CanEditNotes' as AgendaPermission,
  VIEW_FINANCIAL: 'CanViewFinancial' as AgendaPermission,
  EDIT_FINANCIAL: 'CanEditFinancial' as AgendaPermission,
}

export const hasPermission = (
  permissions: AgendaPermission[],
  permission: AgendaPermission,
): boolean => permissions.includes(permission)
